import { time as timeFormat } from '@/helpers/dateTimeFormats';

const timeFormatter = new Intl.DateTimeFormat(undefined, timeFormat);

export default function formatTime(dateTime) {
  if (!dateTime) return '';
  return timeFormatter.format(dateTime);
}
